import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  root: {
    width: 250,
    borderRadius: 8,
    padding: 24,
    overflow: 'hidden',
    border: [1, 'solid', theme.palette.colors.border],
  },
  topBox: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  bottomBox: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderTop: [1, 'dotted', theme.palette.colors.border],
  },
  text: {
    marginTop: theme.spacing(1),
    color: theme.palette.colors.darkBlueGray,
  },
  controlBox: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderTop: [1, 'dotted', theme.palette.colors.border],
    display: 'flex',
    alignItems: 'center',
  },
  applyButton: {
    height: 40,
    '&:hover': {
      color: theme.palette.colors.white,
    },
  },
  icon: {
    fill: theme.palette.colors.white,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/Messages/components/Message/components/BidMessage/useStyles.js